import moment from "moment";
import AbstractApiActioner from "services/cores/abstractApiActioner";

import IndicatorsActionTypes from "./types";
import IndicatorsApi from "./api";
import IndicatorsUtils from "./utils";

class IndicatorsActioner extends AbstractApiActioner {
  setInitialized(key, value) {
    return {
      type: IndicatorsActionTypes.SET_INITIALIZED,
      key,
      value,
    };
  }

  setFilter = (key, value) => {
    return {
      type: IndicatorsActionTypes.SET_FILTER,
      key,
      value,
    };
  };

  setConfigParam = (key, value) => {
    return {
      type: IndicatorsActionTypes.SET_CONFIG_PARAM,
      key,
      value,
    };
  };

  setData = (value) => {
    return {
      type: IndicatorsActionTypes.SET_DATA,
      value,
    };
  };

  setBackofficeSettingsIndicators = (value) => {
    return {
      type: IndicatorsActionTypes.SET_INDICATORS,
      value,
    };
  };

  retrieveIndicators = () => {
    return async (dispatch, getState) => {
      const backofficeIndicators = getState().Indicators.indicators;

      if (backofficeIndicators.length > 0) {
        dispatch(this.setInitialized("indicators", false));
        const from =
          moment(getState().Indicators.filters.from).startOf("day").unix() ??
          moment().subtract(1, "month").startOf("day").unix();
        const to =
          moment(getState().Indicators.filters.to).endOf("days").unix() ??
          moment().endOf("days").unix();

        try {
          const result = await IndicatorsApi.retrieveIndicators(
            backofficeIndicators,
            {
              from,
              to,
            }
          );

          dispatch(this.setData(result.indicators));
          dispatch(this.setInitialized("indicators", true));
        } catch (err) {
          throw err;
        }
      }
    };
  };

  async downloadIndicators(data, title) {
    const result = await IndicatorsApi.downloadIndicators(data);
    const link = document.createElement("a");
    link.href = URL.createObjectURL(result);
    link.download = `${title}.csv`;
    link.click();
    setTimeout(() => URL.revokeObjectURL(link.href), 0);
  }
}

export default new IndicatorsActioner(
  "Indicators",
  IndicatorsActionTypes,
  IndicatorsApi,
  IndicatorsUtils
);
